/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { LIST_PERMISSION__PUBLIC } from '@/constants';
import { syncFirebaseDB } from "@utils/NetworkCalls";

/**
 * Initial state
 * @type {Object}
 */
const state = {
  permissionState: LIST_PERMISSION__PUBLIC,
  exists: true
};

/**
 * Mutations for updating this piece of state
 * Must be synchronous
 *
 * @type {Object}
 */
const mutations = {
  permissionState(state, permission) {
    state.permissionState = permission;
  },
  exists(state, exists) {
    state.exists = exists;
  }
};

/**
 * Actions for updating this piece of state
 * Can contain asynchronous actions
 *
 * @type {Object}
 */
const actions = {
  setListPermission({ commit }, payload) {
    const { permission } = payload;
    commit('permissionState', permission);
  },
  setExists({commit}, payload) {
    const { exists } = payload;
    commit('exists', exists);
  }
};

/**
 * Getter for this piece of state
 *
 * @type {Object}
 */
const getters = {
  permissionState: state => state.permissionState,
  canEditList: (state, getters) => getters.isUserOwner || state.permissionState === LIST_PERMISSION__PUBLIC,
  isUserOwner: (state, getters, rootState, rootGetters) => !rootGetters.urlString || rootGetters.myLists.find(myList => myList.id === rootGetters.urlString),
  listExists: state => state.exists
};

// Module exports
export default {
  // namespaced: true,
  state,
  mutations,
  actions,
  getters
};
